import React, { FC } from 'react';

import { DatabaseMatch, DatabasePlayer, Matches, PlayerResult, UpdateStatus } from '../../../../database.schema';
import { useTournamentResultsMutation } from '../../../api/tournament-data';
import { Button } from '../../common-styles/common-styles';

type UpdateButtonProps = {
  recordedMatches: Matches;
  resultIndex: number;
  selectedTournamentIndex: number;
  setUpdateStatus: (updateStatus: UpdateStatus) => void;
  onSuccess: () => void;
  disabled: boolean;
};

const getPlayers = (resultPlayers: PlayerResult[]): DatabasePlayer[] => {
  const players: DatabasePlayer[] = [];

  resultPlayers.forEach((resultPlayer: PlayerResult) => players.push({ playerId: resultPlayer.playerId, points: resultPlayer.points, round: resultPlayer.round }));
  return players;
};

export const UpdateButton: FC<UpdateButtonProps> = ({ selectedTournamentIndex, resultIndex, recordedMatches, disabled, setUpdateStatus, onSuccess }) => {
  const mutation = useTournamentResultsMutation();
  const saveCourse = () => {
    const form = document.querySelector('form')!;
    const formData = new FormData(form);

    const courseId = Number(formData.get('course'));
    const startingHole = Number(formData.get('startingHole'));

    let index = 0;
    const matches: Array<DatabaseMatch> = [];
    for (index; index < recordedMatches.matches.length; index++) {
      const match = {
        status: 'complete',
        resultMargin: formData.get(`team-result-margin-${index}`) as string,
        resultByHole: recordedMatches.matches[index].resultByHole,
        team1: {
          players: [...getPlayers(recordedMatches.matches[index].team1.players)],
          points: recordedMatches.matches[index].team1.points,
        },
        team2: {
          players: [...getPlayers(recordedMatches.matches[index].team2.players)],
          points: recordedMatches.matches[index].team2.points,
        },
        date: new Date().toISOString(),
      };
      matches.push(match);
    }
    const dataToSave = {
      selectedTournamentIndex,
      resultIndex,
      startingHole,
      courseId,
      resultsFormat: recordedMatches.format,
      matches,
    };
    if (dataToSave) {
      mutation.mutate(
        { ...dataToSave },
        {
          onSuccess: (data) => {
            onSuccess();
          },
          onError: (error) => {
            setUpdateStatus({ success: false, error: true });
            console.log('<><><>ERROR<><><><', error);
          },
        }
      );
    }
  };
  return (
    <Button data-testid="save-button" onClick={() => saveCourse()} disabled={disabled}>
      Save
    </Button>
  );
};
